import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { TabNav } from '../../components/nav/tabNav'
import { PageHeader } from '../../components/typography/PageHeader'
import Layout from '../../layout'
import { InterestsPanel } from '../interests/InterestsPanel'
import { SpendingQuestionsPanel } from '../spending-questions/spending-questions-panel'
import {
  SHOPPING_PREFERENCES_ROUTE,
  SHOPPING_PREFERENCES_TAB,
  type ShoppingPreferencesTab,
} from './shopping-preferences.constant'

const TABS: Array<{ id: ShoppingPreferencesTab; name: string }> = [
  {
    id: SHOPPING_PREFERENCES_TAB.SPENDING_QUESTIONS,
    name: 'Spending Questions',
  },
  { id: SHOPPING_PREFERENCES_TAB.INTERESTS, name: 'Interests' },
]

const isTab = (tab?: string): tab is ShoppingPreferencesTab =>
  TABS.some(({ id }) => id === tab)

/**
 * Spending questions and shopping interests in one module, with a tab for
 * each. The active tab lives in the URL so links, refreshes and the interest
 * form's return navigation land on the right tab.
 */
export function ShoppingPreferencesPage() {
  const { tab } = useParams()
  const navigate = useNavigate()

  if (!isTab(tab)) {
    return (
      <Navigate to={SHOPPING_PREFERENCES_ROUTE.SPENDING_QUESTIONS} replace />
    )
  }

  return (
    <Layout>
      <PageHeader title="Shopping Preferences" />
      <TabNav
        tabs={TABS}
        activeTab={tab}
        setActiveTab={(nextTab) => {
          navigate(`${SHOPPING_PREFERENCES_ROUTE.BASE}/${nextTab}`)
        }}
        className="mb-8"
      />
      {tab === SHOPPING_PREFERENCES_TAB.SPENDING_QUESTIONS ? (
        <SpendingQuestionsPanel />
      ) : (
        <InterestsPanel />
      )}
    </Layout>
  )
}
